import React, { FunctionComponent } from 'react'
import { useAuth0 } from '../contexts/auth0'
import meltanoLogo from 'src/assets/images/svgs/meltano-logo-white.svg'
import 'src/assets/css/views/emailnotverified.css'

/*
 * Shown after sign-up until the user verifies their email address. Styled to
 * follow on from the Auth0 Universal Login pages they have just left (dark page,
 * the same card, colours and type), rather than the app's own chrome.
 */
const EmailNotVerified: FunctionComponent<any> = () => {
  const { logout, user } = useAuth0()
  // only a real address is shown; anything else falls back to generic wording
  const email = typeof user?.email === 'string' ? user.email : undefined

  const logoutWithRedirect = () => {
    logout({
      returnTo: window.location.origin
    })
  }

  return (
        <div className="emailnotverified">
            <main className="emailnotverified-card">
                <img className="emailnotverified-logo" src={meltanoLogo} alt="Meltano" />
                <svg
                    className="emailnotverified-icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    focusable="false"
                >
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <path d="M3.5 6.5 12 13l8.5-6.5" />
                </svg>
                <h1>Please check your email and verify your account</h1>
                {email
                  ? (
                    <>
                        {/* the address gets a line of its own so it isn't wrapped mid-sentence */}
                        <p>We&apos;ve sent a verification link to:</p>
                        <p className="emailnotverified-email"><strong>{email}</strong></p>
                        <p>Open it to activate your account, then sign in again.</p>
                    </>
                    )
                  : (
                    <p>
                        We&apos;ve sent a verification link to your email address. Open it to
                        activate your account, then sign in again.
                    </p>
                    )}
                <p className="emailnotverified-hint">
                    Can&apos;t find it? Check your spam or junk folder.
                </p>
                <a
                    className="emailnotverified-button"
                    href="/"
                    onClick={evt => {
                      evt.preventDefault()
                      logoutWithRedirect()
                    }}
                >
                    Return to Login
                </a>
            </main>
        </div>
  )
}

export default EmailNotVerified
